export enum MarketSegmentAPIResponse {
  Land = 'land',
  Retail = 'retail',
  Other = 'other',
  Hotel = 'hotel',
  DataCenter = 'dataCenter',
  Industrial = 'industrial',
  Office = 'office',
  LifeScience = 'lifeScience',
  HealthcareFacility = 'healthcareFacility',
  ParkingGarage = 'parkingGarage',
  Residential = 'residential',
  SelfStorage = 'selfStorage',
  MobileHomePark = 'mobileHomePark',
  ColdStorageFacility = 'coldStorageFacility',
  Multifamily = 'multifamily',
  RVPark = 'rvPark',
}
